module.exports = __webpack_public_path__ + "img/IconLocation.e9f249e2.svg";